$(document).ready(function(){
  $(".accordion-div-svg").click(function(){
    var mydata1 = $(this).attr("data1");
    console.log(mydata1, "mydata1");

    var $content = $(this).siblings(".accordion-content");
    var mydata2 = $content.attr("data2");
    console.log(mydata2, "mydata2");


    if (mydata1 == mydata2) {
      if ($content.hasClass("cstm-active")) {
       
        $content.removeClass("cstm-active").css("display", "none");
        $(this).find(".visible-icon").removeClass("visible");
        $(this).find(".hidden-icon").removeClass("cstm-svg-active");
      } else {
     
        $(".accordion-content").removeClass("cstm-active").css("display", "none");
        $(".visible-icon").removeClass("visible");
        $(".hidden-icon").removeClass("cstm-svg-active");
        
       
        $content.addClass("cstm-active").css("display", "block");
        $(this).find(".visible-icon").addClass("visible");
        $(this).find(".hidden-icon").addClass("cstm-svg-active");
      }
    }
  });
});


$(document).ready(function(){
 $(".baseball-about-section-class.owl-carousel").addClass("owl-carousel");
  $(".baseball-about-section-class.owl-carousel").owlCarousel({
    loop: false,
    margin: 0,
    nav: true,
    dots: true,
    autoplay: false,
    navText: [
      "<button class='circle-button ring group' is='prev-button'><span class='sr-only'>Previous</span><span class='animated-arrow animated-arrow--reverse'></span></button>",
      "<button class='circle-button ring group' is='next-button'><span class='sr-only'>Next</span><span class='animated-arrow'></span></button>",
    ],
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  });
});

